import cn from "classnames";
import { Datetime, Field, Select } from "components/shared/form";
import { serializeReq, validateForm } from "helpers/form";
import { ymEvent } from "helpers/system";
import moment from "moment";
import React, { useCallback, useEffect, useState } from "react";
import { deletePassportData, getPassportData, setPassportData } from "sources/books/drivers";
import { getPassportConfig } from "./formConfig";

export default function DriverPassportData(props) {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState({});
    const [canDelete, setCanDelete] = useState(false);
    const [valid, setValid] = useState(true);

    const fetchData = useCallback(() => {
        setLoading(true);
        getPassportData(props.id).then((res) => {
            setData(res || {});
            setCanDelete(!!res);
            setLoading(false);
        });
    }, [props.id]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const setValue = ({ name, value }) => {
        let val = value;
        if (name === "series" || name === "number") {
            if (typeof val === "string") {
                val = val.toUpperCase();
            }
        }
        setData({ ...data, [name]: val });
    };

    const renderField = (name) => {
        const currentConfig = getPassportConfig(data?.issuingCountry);
        return (
            <Field
                {...currentConfig[name]}
                value={data ? data[name] : ""}
                onChange={setValue}
                labelWrapper="col-12 col-form-label col-form-label-sm text-muted"
                fieldWrapper="col-12"
            />
        );
    };

    const renderSelect = (name) => {
        const currentConfig = getPassportConfig(data?.issuingCountry);
        return (
            <Select
                {...currentConfig[name]}
                value={data ? data[name] : ""}
                onChange={setValue}
                labelWrapper="col-12 col-form-label col-form-label-sm text-muted"
                fieldWrapper="col-12"
            />
        );
    };

    const renderDateField = (name) => {
        const currentConfig = getPassportConfig(data?.issuingCountry);
        return (
            <Datetime
                {...currentConfig[name]}
                value={data ? data[name] : ""}
                onChange={setValue}
                labelWrapper="col-12 col-form-label col-form-label-sm text-muted"
                fieldWrapper="col-12"
            />
        );
    };

    const submitForm = (e) => {
        e.preventDefault();
        ymEvent("SavePassportDetails");
        setLoading(true);
        const serialized = { ...serializeReq(data) };
        const currentConfig = getPassportConfig(data?.issuingCountry);
        if (validateForm(currentConfig, serializeReq(data))) {
            serialized.dateOfIssue = moment(serialized.dateOfIssue).format("YYYY-MM-DD");
            serialized.driverId = props.id;
            setValid(true);
            setPassportData(serialized).then((res) => {
                setCanDelete(!!res);
                setLoading(false);
            });
        } else {
            setValid(false);
            setLoading(false);
        }
    };

    const deleteItem = () => {
        props.modal({
            name: "confirm",
            title: "Вы действительно хотите удалить данные?",
            action: () => deletePassportData({ driverId: props.id }).then(fetchData),
            buttons: { confirm: "Да", cancel: "Нет" },
        });
    };

    return (
        <div className="card card-body mb-3">
            <h5>Паспорт</h5>
            <form className={cn({ loading, "book-form__body--invalid": !valid })} onSubmit={submitForm}>
                {renderSelect("issuingCountry")}
                {renderField("series")}
                {renderField("number")}
                {renderField("issuedBy")}
                {renderDateField("dateOfIssue")}
                {renderField("subdivisionCode")}
                <div className="d-flex justify-content-between">
                    {canDelete ? (
                        <button className="btn btn-sm btn-outline-danger" type="button" onClick={deleteItem}>
                            Удалить
                        </button>
                    ) : (
                        <div />
                    )}
                    <button className="btn btn-sm btn-brand" type="submit">
                        Сохранить
                    </button>
                </div>
            </form>
        </div>
    );
}
